export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f4cb22d2bf59af8b118052340ca9048109cb6cf7&name=pushAdClickData!'